import styled from "styled-components";
import StudentCounsel from "./StudentCounsel";
import StudentScore from "./StudentScore";
import StudentAttendance from "./StudentAttendance";
import { useLocation } from "react-router-dom";
import StudentActivityPreview from "./StudentActivityPreview";
import useStudentProfileMain from "features/teacher/hooks/student/useStudentProfileMain";
import StudentActivity from "./StudentActivity";

const StudentProfileMain = () => {
    const student_uid = useLocation().state;
    const { showActivityModal, onActivityClick, onActivityCancelClick } = useStudentProfileMain();
    return (
        <Container>
            {showActivityModal ? <StudentActivity onCancelClick={onActivityCancelClick} studentUid={student_uid} /> : null}
            <Main>
                <StudentActivityPreview onClick={onActivityClick} studentUid={student_uid} />
                <Row>
                    <StudentScore studentUid={student_uid} />
                    <StudentAttendance studentUid={student_uid} />
                </Row>
            </Main>
            <StudentCounsel student_uid={student_uid} />
        </Container>
    );
};

const Container = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1.4fr) minmax(280px, 0.7fr);
    gap: 16px;
    flex: 1;
    min-height: 0;

    @media (max-width: 1100px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

const Main = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 0;
`;

const Row = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1.4fr) minmax(220px, 0.7fr);
    gap: 16px;
    flex: 1;
    min-height: 0;

    @media (max-width: 800px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

export default StudentProfileMain;
